var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.3772,
    r: 13.5293,
    fill: "url(#paint0_linear_4229_8283)",
    stroke: "url(#paint1_linear_4229_8283)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0547 21.0363C14.2062 21.0363 13.4524 20.8829 12.7933 20.5761C12.1342 20.2692 11.6134 19.8469 11.2308 19.309C10.852 18.7711 10.6551 18.1537 10.6399 17.4567H13.3672C13.3899 17.8848 13.5642 18.2295 13.8899 18.4908C14.2157 18.7484 14.6039 18.8772 15.0547 18.8772C15.407 18.8772 15.7195 18.7995 15.9922 18.6442C16.2649 18.4889 16.4789 18.2711 16.6342 17.9908C16.7895 17.7067 16.8653 17.381 16.8615 17.0136C16.8653 16.6386 16.7876 16.3109 16.6286 16.0306C16.4732 15.7503 16.2573 15.5325 15.9808 15.3772C15.7081 15.2181 15.3937 15.1386 15.0376 15.1386C14.7005 15.1348 14.3804 15.2086 14.0774 15.3602C13.7782 15.5117 13.5509 15.7181 13.3956 15.9795L10.9126 15.5136L11.4183 9.24083H18.8842V11.5079H13.7308L13.4638 14.2522H13.532C13.7251 13.9302 14.0357 13.6651 14.4638 13.4567C14.8956 13.2446 15.3861 13.1386 15.9354 13.1386C16.6323 13.1386 17.2536 13.3014 17.799 13.6272C18.3482 13.9492 18.7801 14.3961 19.0945 14.9681C19.4126 15.5401 19.5717 16.1954 19.5717 16.934C19.5717 17.7333 19.3823 18.4416 19.0036 19.059C18.6286 19.6764 18.102 20.1613 17.424 20.5136C16.7498 20.862 15.96 21.0363 15.0547 21.0363Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_8283",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3E52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4229_8283",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11273D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank5);
export default __webpack_public_path__ + "static/media/rank5.e8e2e277299508117e5eeec11a7d066f.svg";
export { ForwardRef as ReactComponent };